/* eslint-disable */
export default function toggleAfterPay() {
    document.addEventListener('DOMContentLoaded', function () {
      const viewOptionsBtn = document.getElementById('afterpayViewOptions');
      const modalOverlay = document.getElementById('afterpay-modalOverlay');
      const afterpayModal = document.getElementById('afterpayModal');
      const modalClose = document.getElementById('modalClose');
  
      function openModal() {
        modalOverlay.style.display = 'block';
        setTimeout(() => {
          document.addEventListener('click', handleOutsideClick);
        }, 10);
      }
  
      function closeModal() {
        modalOverlay.style.display = 'none';
        document.removeEventListener('click', handleOutsideClick);
      }
  
      function handleOutsideClick(event) {
        if (!afterpayModal.contains(event.target) && event.target !== viewOptionsBtn) {
          closeModal();
        }
      }

      if (viewOptionsBtn) {
        viewOptionsBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          openModal();
        });
      }

      if (modalClose) {
        modalClose.addEventListener('click', closeModal);
      }
    });
  }
  